// GTM Event: Quote Form Submission
// Page: /pages/request-a-quote

(function() {
  if (!window.location.pathname.includes('/pages/request-a-quote')) {
    return;
  }

  let sent = false;
  const emailUtils = window.GTMEmailUtils || {};

  function getEmailFromForm() {
    if (typeof emailUtils.getEmailFromForm === 'function') {
      return emailUtils.getEmailFromForm();
    }

    return '';
  }

  function push(source) {
    if (sent) return;
    window.dataLayer = window.dataLayer || [];

    const payload = {
      event: 'quote_form_submission',
      formID: 'Quote',
      lead_type: 'quote_request',
      lead_status: 'submitted',
      lead_source: 'request_a_quote_page',
      provider: 'quote_app_or_hubspot',
      page_path: window.location.pathname,
      trigger_source: source,
      email: getEmailFromForm()
    };

    window.dataLayer.push(payload);

    sent = true;
  }

  // HubSpot success via postMessage
  window.addEventListener('message', function(event) {
    const raw = event?.data;
    const text = (typeof raw === 'string' ? raw : JSON.stringify(raw || '')).toLowerCase();
    if (text.includes('hsformcallback') && text.includes('onformsubmitted')) {
      push('hubspot_postmessage');
    }
  });

  // RFQ success when submit-step state appears
  if (typeof MutationObserver !== 'undefined' && document.body) {
    const observer = new MutationObserver(function() {
      if (document.querySelector('.omgrfq-content-step-submit')) {
        push('quote_submit_step_class');
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
